import { action, makeAutoObservable } from 'mobx';
import agent from '../api/agent';
import { ReporteBanrural, ReporteBanruralFormValues } from '../models/ReporteBanrural';
import { Pagination } from '../models/CATCursos';

export default class ReporteBanruralStore {

    BusquedaRegistry = new Map<any, ReporteBanrural>();
    
    selectedReporteBanrural: ReporteBanrural | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
 
    totalPages: number = 1;
    currentPage = 1;
 
    @action setPage(page: number) {
        this.currentPage = page;}

        
    constructor() {
        makeAutoObservable(this)
    }

    get ReporteBanruralByCodigo() {
        return Array.from(this.BusquedaRegistry.values());
    }

    get groupedCCTiposDeCuentas() {
        return this.BusquedaRegistry
    }
    
    busquedaInforme = async (valor: any, page: number, size: number) => {
        this.loadingInitial = true;
        this.BusquedaRegistry.clear()
        try {
            const asignar: Pagination<ReporteBanruralFormValues> = await agent.Reportes.banrural(valor, page, size)
            asignar.records.forEach(element => {
                this.setReporteBanrural(element)
            })
            this.totalPages = asignar.totalPages
            this.setLoadingInitial(false)
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    descargaInforme = async (valor: any) => {
        try {
          const response = await agent.Reportes.banruralExport(valor);
          const blob = new Blob([response], { type: 'text/csv;charset=utf-8' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'dataBanrural.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.error(error);
        }
    };

    private setReporteBanrural = (data: ReporteBanruralFormValues) => {
        this.BusquedaRegistry.set(data.id, data);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }
}